import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React, { PropsWithChildren } from 'react';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

if (typeof window !== 'undefined' && posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
  });
}

// Export posthog instance for use in router navigation tracking
// eslint-disable-next-line react-refresh/only-export-components
export { posthog };

export function CSPostHogProvider({ children }: PropsWithChildren) {
  // If there's no key, just render the children without the provider.
  if (!posthogKey) return <>{children}</>;

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
